<template>
<div>
<!-- <div class="hero-about bg-alt h-500"></div> -->

    <div class="py-md-3 py-lg-5 px-xl-6 px-4">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-10 offset-md-1 push-40 pt-10">
                    <h3 class="mb-5">Opps 404!</h3>
                </div>

                <div class="col-12 col-md-10 offset-md-1 push-40">
                    <p>Unfortunately we can't find the page you are looking for! Your provided link may have been mispelled or we may have potentially removed the page.</p>

                    <p>Head back to the <router-link :to="{ name: 'home' }">Home Page</router-link> and try searching again! Alternatively, feel free to leave a <router-link :to="{ name: 'contact' }">Contact Message</router-link> and we can follow up your request as soon as possible.</p>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
export default {
    name: 'FourOhFour',
};
</script>


// WEBPACK FOOTER //
// src/components/FourOhFour.vue